<figure (click)="toggleBookmark()"
  class="w-8 flex justify-center items-center rounded-full aspect-square absolute top-2 md:top-4 right-2 md:right-4 z-20 cursor-pointer hover-svg">
  <svg width="12" height="14" xmlns="http://www.w3.org/2000/svg">
    <path d="m10.518.75.399 12.214-5.084-4.24-4.535 4.426L.75 1.036l9.768-.285Z" stroke="currentColor"
      stroke-width="1.5" fill="transparent" class="transition-colors duration-300"
      [ngClass]="{'fill-current': data?.isBookmarked}" />
  </svg>
</figure>